export const NO_DATE_SYMBOL = Symbol('NO_DATE')
